<template>
  <v-container>
    <v-row>
      <v-col>
        <p>Удаляет множество пресетов за один запрос. Принимает один параметр – presetids – перечисление идентификаторов пресетов, разделенных символом «,».</p>

        <div class="text-subtitle-1">Заголовки запроса</div>
        <v-simple-table>
          <thead>
            <tr>
              <td>
                <b>Заголовок</b>
              </td>
              <td>
                <b>Описание</b>
              </td>
              <td>
                <b>Пример значения</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Authorization</td>
              <td>JWT токен доступа</td>
              <td>Bearer eyJhbGciOiJSUzI1NiIsImtp...</td>
            </tr>
            <tr>
              <td>Accept-Encoding</td>
              <td>
                Вы можете указать параметр gzip для сжатия ответа. Настоятельно рекомендуем использовать этот заголовок!
                Например, если без сжатия, ответ занимает 4 мегабайта, то с gzip сжатием он будет занимать около 150 килобайт.
              </td>
              <td>gzip</td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="text-subtitle-1">Типы запросов</div>

        <v-simple-table>
          <thead>
            <tr>
              <td>
                <b>Пример</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <code>curl -H 'Authorization: Bearer eyJhbGciOiJSUzI1NiIsImtp...' -X DELETE {{ $settings.VUE_APP_GATEWAY_SERVICE_ENDPOINT }}/api/1.2/presets?presetIds=id1,id2</code>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="text-subtitle-1">Ответ</div>

        <v-simple-table class="table">
          <thead>
            <tr>
              <td>
                <b>Пример ответа</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <json-viewer :value="response" copyable boxed sort></json-viewer>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card>
          <div class="text-h5">Территория</div>
          <div class="text-subtitle-1">Общие сведения</div>
          <p>
            Для работы с данным API вам необходимо передать три параметра: широту, долготу и идентификатор территории. Широта и долгота определяют координаты точки
            в которой вы ходите получить прогноз. Идентификатор территории определяет территорию для которой посчитан прогноз.
          </p>
          <p>Получить список активных территорий можно с помощью API.</p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: function() {
    return {
      response: {
        status_code: 200
      }
    };
  }
};
</script>